/**
 * Catalogo de informes del hub: metadatos de UI y filtros.
 * La lista clicable esta en reportHub-page.html; aqui solo se resuelve la definicion por reportId.
 */

const REPORT_DEFINITIONS = [
  // —— Customer ——
  {
    entity: "customer",
    id: "account-receivable-one",
    label: "Accounts receivable — one customer",
    needsAutocomplete: true,
    autocompleteEntity: "customer",
    autoPrintWithoutUI: false,
    filterDateRange: true,
    filterYear: true,
  },
  {
    entity: "customer",
    id: "account-receivable-all",
    label: "Accounts receivable — all customers",
    needsAutocomplete: false,
    autoPrintWithoutUI: true,
    filterDateRange: true,
    filterYear: true,
  },
  {
    entity: "customer",
    id: "customer-profit-all",
    label: "Customer profit — all customers",
    needsAutocomplete: false,
    autoPrintWithoutUI: true,
    filterDateRange: false,
    filterYear: false,
  },
  {
    entity: "customer",
    id: "customer-profit-one",
    label: "Customer profit — one customer",
    needsAutocomplete: true,
    autocompleteEntity: "customer",
    autoPrintWithoutUI: false,
    filterDateRange: true,
    filterYear: true,
  },

  // —— Provider ——
  {
    entity: "provider",
    id: "account-payable-one",
    label: "Accounts payable — one provider",
    needsAutocomplete: true,
    autocompleteEntity: "provider",
    autoPrintWithoutUI: false,
    filterDateRange: true,
    filterYear: true,
  },
  {
    entity: "provider",
    id: "account-payable-all",
    label: "Accounts payable — all providers",
    needsAutocomplete: false,
    autoPrintWithoutUI: true,
    filterDateRange: true,
    filterYear: true,
  },
  {
    entity: "provider",
    id: "provider-profit-all",
    label: "Provider profit — all providers",
    needsAutocomplete: false,
    autoPrintWithoutUI: true,
    filterDateRange: false,
    filterYear: false,
  },
  {
    entity: "provider",
    id: "provider-profit-one",
    label: "Provider profit — one provider",
    needsAutocomplete: true,
    autocompleteEntity: "provider",
    autoPrintWithoutUI: false,
    filterDateRange: true,
    filterYear: true,
  },

  // —— Purchase ——
  {
    entity: "purchase",
    id: "purchase-status",
    label: "Purchase — status report",
    needsAutocomplete: true,
    autocompleteEntity: "purchase",
    autoPrintWithoutUI: false,
    filterDateRange: true,
    filterYear: true,
  },
  {
    entity: "purchase",
    id: "purchase-invoice-pdf",
    label: "Purchase — invoice (PDF)",
    needsAutocomplete: true,
    autocompleteEntity: "purchase",
    autoPrintWithoutUI: false,
    filterDateRange: true,
    filterYear: true,
  },

  // —— Sale ——
  {
    entity: "sale",
    id: "sale-invoice-pdf",
    label: "Sale — invoice (PDF)",
    needsAutocomplete: true,
    autocompleteEntity: "sale",
    autoPrintWithoutUI: false,
    filterDateRange: true,
    filterYear: true,
  },
  {
    entity: "sale",
    id: "sale-pack-slip-pdf",
    label: "Sale — packing slip (PDF)",
    needsAutocomplete: true,
    autocompleteEntity: "sale",
    autoPrintWithoutUI: false,
    filterDateRange: true,
    filterYear: true,
  },

  // —— Inventory ——
  {
    entity: "inventory",
    id: "inventory-items-available",
    label: "Inventory — items available",
    needsAutocomplete: false,
    autoPrintWithoutUI: true,
    filterDateRange: false,
    filterYear: false,
  },

  // —— Transaction ——
  {
    entity: "receivepayment",
    id: "receivepayment-one",
    label: "Transaction — receive payment (one)",
    needsAutocomplete: true,
    autocompleteEntity: "customer",
    autoPrintWithoutUI: false,
    filterDateRange: true,
    filterYear: true,
  },
  {
    entity: "sentpayment",
    id: "sentpayment-one",
    label: "Transaction — send payment (one)",
    needsAutocomplete: true,
    autocompleteEntity: "provider",
    autoPrintWithoutUI: false,
    filterDateRange: true,
    filterYear: true,
  },
];

export function getReportDefinition(reportId) {
  return REPORT_DEFINITIONS.find((r) => r.id === reportId);
}
